import claims from '@/store/modules/extras/claims';
import { ContentTypes } from '@/constants/linkContent';

export default {
  namespaced: true,
  modules: {
    claims,
  },
  state: {
    createLoading: false,
    userExtras: null,
    userExtrasLoading: false,
  },
  mutations: {
    setUserExtrasLoading(state, isLoading) {
      state.userExtrasLoading = isLoading;
    },
    setCreateLoading(state, isLoading) {
      state.createLoading = isLoading;
    },
  },
  actions: {
    async create({ commit, dispatch }) {
      try {
        commit('setCreateLoading', true);
        return dispatch('content/createContent', ContentTypes.EXTRAS, { root: true });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setCreateLoading', false);
      }
    },
  },
  getters: {
    createLoading: state => state.createLoading,
    userExtras: state => state.userExtras || [],
    userExtrasLoading: state => state.userExtrasLoading,
  },
};
